import { Component, OnInit, Optional, Input } from '@angular/core';
import { NgControl } from '@angular/forms';


@Component({
  selector: 'file360-field-error',
  templateUrl: './field-error.component.html',
  styleUrls: ['./field-error.component.scss']
})
export class FieldErrorComponent implements OnInit {

  /**
   * A unique elementId for this field. The elementId passes on to label to 
   * know which form element the label is bound to. This property is optional.
  */
  @Input() elementId: string | undefined = "";

  // Injecting NgControl -- super class to all other form directives
  // controlDir is the form field directive hosting this label
  constructor(@Optional() public controlDir: NgControl) {

  }

  ngOnInit() {
  }

  get isError(): boolean | null {
    if (this.controlDir != null) {
      return this.controlDir.invalid && (this.controlDir.dirty || this.controlDir.touched);
    }
    return false;
  }
}